import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/shared/services/api.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-package-list',
  templateUrl: './package-list.component.html',
  styleUrl: './package-list.component.css'
})
export class PackageListComponent {


  packages: any[] = [];
  displayedColumns: string[] = ['id', 'package_name', 'amount', 'duration', 'actions'];
  dataSource = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  constructor(
    private apiService: ApiService,
    private router: Router,
    private toastrMsgService: ToastrService
  ) { }

  ngOnInit(): void {
    this.loadPackages();
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  filterByStatus(status: any) {
    this.dataSource.filterPredicate = (data, filter) =>
      !filter || data.kycStatus.toLowerCase() === filter;
    this.dataSource.filter = status.toLowerCase();
  }

  loadPackages(): void {
    this.apiService.getAllPackageDetails().subscribe({
      next: (res: any) => {
        this.packages = res.data;
        this.dataSource=res.data;
      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log('Observable complete'),
    });

  }

  addNewPackage(): void {
    this.router.navigate(['/home/add-package']);
  }

  editPackage(id: number): void {
    this.router.navigate(['/home/edit-package', id]);
  }

  deletePackage(id: number): void {
    if (confirm('Are you sure you want to delete this package?')) {
      this.apiService.deletePackage(id).subscribe(() => {
        this.loadPackages(); // reload
      });
    }
  }
}
